//
//
//
//
//
//
//
//
//
//
//

import { format } from 'mathjs';

export default {
  name: "TheDecimalInput",
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Введите значение"
    }
  },
  data() {
    return {
      inputValue: "",
    };
  },
  computed: {
    formattedValue: {
      get() {
        return this.inputValue;
      },
      set(newValue) {
        this.inputValue = newValue;

        switch (newValue) {
        case '':
        case '-':
        case '-0':
        case '-0.':
          if (newValue === '') {
            this.$emit('input', null);
          }
          return;
        default:
          if (newValue.startsWith('-0.') && isNaN(newValue / 0)) {
            this.$emit('input', null);
            return;
          }
        }

        this.$emit("input", parseFloat(newValue));
      },
    },
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal !== null ? this.toDecimal(newVal) : '';
    },
  },
  mounted() {
    this.inputValue = this.value !== null ? this.toDecimal(parseFloat(this.value)) : ""
  },
  methods: {
    validateInput() {
      if (this.inputValue === '') {
        this.$emit('input', null);
        return;
      }
      //  else if (this.inputValue === '-') {
      //   this.$emit('input', null);
      //   return;
      // }
      const regex = /^[-]?(\d*([.,]\d*)?([eE][-+]?\d+)?|([.,]\d+)?([eE][-+]?\d+)?)$/;
      if (regex.test(this.inputValue)) {
        this.formattedValue = this.inputValue.replace(",", ".");
      } else {
        this.inputValue = this.value !== null ? this.toDecimal(this.value) : '';
      }
    },
    toDecimal(number) {
      if (typeof number !== 'number') return number;

      return format(number, {
        notation: 'fixed',
        lowerExp: -50,
        upperExp: 100,
      });
    },
  },
}
